import Select                                       from 'react-select';
import api                                          from '../../services/api.js';
import { toSelectOptions }                          from '../../utils/reactUtils';

import { useState, useEffect, useMemo }             from 'react'
import { useMassBalancePage }                       from '../../contexts/MassBalancePageContext'


function SelectTerminal() {

    const [terminals, setTerminals] = useState([]);
    const { selectedTerminal, setSelectedTerminal } = useMassBalancePage();

    // Opção "Todos": leva junto a lista de terminais reais, para quem
    // consome o filtro poder buscar os dados de cada um.
    const allOption = useMemo(() => ({
        id: 'all',
        name: 'Todos',
        value: 'all',
        label: 'Todos',
        isAll: true,
        terminals
    }), [terminals]);


    useEffect(() => {
        
        const fetchTerminals = async () => {
            try {
                
                const response = await api.get('/getAllTerminals');
                const terminalOptions = toSelectOptions(response.data.terminals);

                setTerminals(terminalOptions);
                setSelectedTerminal({
                    id: 'all',
                    name: 'Todos',
                    value: 'all',
                    label: 'Todos',
                    isAll: true,
                    terminals: terminalOptions
                });

            } catch (error) {
                console.error(error);
            }
        }

        fetchTerminals();

    }, []);
    
    return (

        <div className="flex flex-col w-48">
            
           

            <Select
                options={[allOption, ...terminals]}
                value={selectedTerminal}
                onChange={setSelectedTerminal}
                classNamePrefix="select"
                placeholder="Selecione"
            />

        </div>
    )
}

export default SelectTerminal